<template>
  <div
    class="border border-solid border-grey-200 bg-white shadow sm:rounded-lg"
  >
    <div>
      <slot name="header"></slot>
    </div>
    <div>
      <slot name="content"></slot>
    </div>
    <div>
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'card-layout',
};
</script>
